const titleCase = (text) => {
  return text !== "N/A" ? text
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ") : text;
};

export default titleCase;
